<div class="popup">
  <header class="title">
    <h4>{{ 'SWITCH_ACCOUNTS.TITLE' | translate }}</h4>
    <ion-button fill="clear" size="small" (click)="onDismiss()" aria-label="Close">
      <ion-icon name="close" slot="icon-only"></ion-icon>
    </ion-button>
  </header>
  <div class="read-only-section">
    <ion-list class="account-info account-info-current">
      <ion-item class="vertical" lines="none">
        <ion-label>{{ 'SWITCH_ACCOUNTS.CURRENT_ACCOUNT' | translate }}</ion-label>
        <p *ngIf="!retrievingAccountInformation">{{ getAccountName(current_account) }}</p>
        <p *ngIf="retrievingAccountInformation"><ion-spinner name="bubbles"></ion-spinner></p>
      </ion-item>
    </ion-list>

    <div class="read-only-divider"></div>

    <ion-list class="account-info account-info-default">
      <ion-item class="vertical" lines="none">
        <ion-label>{{ 'SWITCH_ACCOUNTS.DEFAULT_ACCOUNT' | translate }}</ion-label>
        <p *ngIf="!retrievingAccountInformation">{{ getAccountName(default_account) }}</p>
        <p *ngIf="retrievingAccountInformation"><ion-spinner name="bubbles"></ion-spinner></p>
      </ion-item>
    </ion-list>
  </div>

  <!-- Form panel: only shown after "View different account" or "Change default" -->
  <section *ngIf="changingCurrent || changingDefault" class="account-form-panel" role="region"
    [attr.aria-labelledby]="'form-heading'">
    <h5 id="form-heading" class="form-panel-title">
      {{ (changingCurrent ? 'SWITCH_ACCOUNTS.VIEW_DIFFERENT_ACCOUNT_LABEL' : 'SWITCH_ACCOUNTS.CHANGE_DEFAULT_ACCOUNT_LABEL') | translate }}
    </h5>
    <form [formGroup]="accountForm" (ngSubmit)="save(accountForm.value)" id="switch-account-form">
      <p class="form-note" *ngIf="changingCurrent"><sup>*</sup>{{ 'SWITCH_ACCOUNTS.NOT_PERMANENT_NOTE' | translate }}</p>
      <p class="form-note" *ngIf="!changingCurrent"><sup>*</sup>{{ 'SWITCH_ACCOUNTS.CHANGE_DEFAULT_NOTE' | translate }}</p>
      <ion-item fill="solid">
        <ion-select formControlName="account" *ngIf="users_accounts && users_accounts.length > 0" color="medium" slot="end">
          <ion-select-option *ngFor="let acct of users_accounts" [value]="acct.id">{{ acct.name }}</ion-select-option>
        </ion-select>
      </ion-item>
      <p class="no-accounts" *ngIf="!users_accounts || (users_accounts && users_accounts.length === 0)">{{ 'SWITCH_ACCOUNTS.NO_ACCOUNTS' | translate }}</p>
    </form>
  </section>

  <div class="button-bar">
    <ion-button (click)="onDismiss()" class="close" size="default" color="light">{{ 'SWITCH_ACCOUNTS.CLOSE' | translate }}</ion-button>
    <ng-container *ngIf="changingCurrent || changingDefault">
      <ion-button color="dark" size="default" (click)="changingDefault = false; changingCurrent = false;">
        {{ 'SWITCH_ACCOUNTS.CANCEL' | translate }}
      </ion-button>      
      <ion-button *ngIf="changingDefault" (click)="save(accountForm.value)" size="default"
        class="submit" color="tertiary" type="submit">{{ 'SWITCH_ACCOUNTS.CHANGE_AND_VIEW_DEFAULT' | translate }}</ion-button>
        <ion-button *ngIf="changingCurrent" (click)="save(accountForm.value)" size="default"
        class="submit" color="tertiary" type="submit">{{ 'SWITCH_ACCOUNTS.VIEW_ACCOUNT' | translate }}</ion-button>
    </ng-container>
    <ng-container *ngIf="!retrievingAccountInformation && !changingCurrent && !changingDefault">
      <ion-button (click)="changingCurrent = true; changingDefault = false; updateForm(current_account);"
        class="btn-view-account" color="primary" fill="outline" size="default">
        {{ 'SWITCH_ACCOUNTS.VIEW_DIFFERENT_ACCOUNT' | translate }}
      </ion-button>
      <ion-button (click)="changingDefault = true; changingCurrent = false; updateForm(default_account);"
        class="secondary" color="medium" size="default">
        {{ 'SWITCH_ACCOUNTS.CHANGE_DEFAULT' | translate }}
      </ion-button>
    </ng-container>    
  </div>
</div>
